export const EXABORGANIZATIONLEAD_DELETE_RESET = 'EXABORGANIZATIONLEAD_DELETE_RESET'
export const EXABORGANIZATIONLEAD_DELETE_SET_ERROR = 'EXABORGANIZATIONLEAD_DELETE_SET_ERROR'
export const EXABORGANIZATIONLEAD_DELETE_SET_DELETED = 'EXABORGANIZATIONLEAD_DELETE_SET_DELETED'
export const EXABORGANIZATIONLEAD_DELETE_TOGGLE_LOADING = 'EXABORGANIZATIONLEAD_DELETE_TOGGLE_LOADING'
